// make filenames safe for sensitive OSs - removing periods and apostrophes
export const escapeDownloadString = (str: string) => str.replace(/\.|'/g, '');

export const stripDiacritics = (str: string) => str.normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const searchFormattedString = (str: string) => stripDiacritics(str).toLowerCase();

// Best-effort surname extraction: the final whitespace-separated token of a name. Returns '' for empty input.
export const lastToken = (str: string) => str.trim().split(/\s+/).filter(Boolean).at(-1) ?? '';
